import moment from "moment";
import "moment/locale/de";
const fromDate = moment().format("YYYY-MM-DD");
export const periodsRange: any[] = [
  {
    id: 1,
    name: "all",
    value: {
      fromDate: "all",
      toDate: "all",
    },
  },
  {
    id: 2,
    name: "this week",
    value: {
      fromDate,
      toDate: moment().add(1, "week").format("YYYY-MM-DD"),
    },
  },
  {
    id: 3,
    name: "this month",
    value: {
      fromDate,
      toDate: moment().add(1, "M").format("YYYY-MM-DD"),
    },
  },
  {
    id: 4,
    name: "last 6 months",
    value: {
      fromDate,
      toDate: moment().add(6, "M").format("YYYY-MM-DD"),
    },
  },
];
